import { render, staticRenderFns } from "./Generales.vue?vue&type=template&id=258672fd&"
import script from "./Generales.vue?vue&type=script&lang=js&"
export * from "./Generales.vue?vue&type=script&lang=js&"
import style0 from "./Generales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports